import TransfersPage, { getDefaultPageData, getDefaultPageUI } from "components/pages/TransfersPage";
import { BCMSDefaultModel, BCMSStateManagerCRUD, BCMSRecord, useBCMSContext, useModel } from "bcms-react";
import Classes, { TransferTemplate, User, UserAccount } from "model";
import { useEffect, useState } from "react";

/**
 * @name CaptureMakeATransferTemplateMain
 * @returns {React.Component}
 * @description 
 * This capture is used in the following capture groups:
 * "Transfer Templates" (abi22).
 */
export default function CaptureMakeATransferTemplateMain(props) {
    const context = useBCMSContext();
    const model = useModel();
    BCMSRecord.globalControllerFor(Classes, context);
    const [ updateComp, setUpdateComp ] = useState(false);

    const defaultData = getDefaultPageData();
    let transfer = defaultData.transfer;
    const addedTemplate = TransferTemplate.init({ 
        id: TransferTemplate.nextID(), 
        name: "Sample", 
        fromAccount: "6",
        toAccount: "5",
        defaultAmount: "100",
        maxAmount: "1000"
    });
    transfer.template = addedTemplate;
    transfer.amount = addedTemplate.defaultAmount;
    transfer.description = "Sample Template";
    transfer.schedule = "Immediate or Future (One Time)";
    const templates = [ ...TransferTemplate.initAll(), addedTemplate ]

    const data = BCMSStateManagerCRUD.init(defaultData)
    .update([ "transferTemplates" ], templates)
    .submit();
    
    // We need to update "User" globally since pages like "TransferPage"
    // only modify the page, not shared content like the header.
    useEffect(() => {
        let user = model.user;
        const defaultUserAccount = BCMSDefaultModel.userAccount();
        
        user = { 
            ...user, 
            first: defaultUserAccount.first, 
            last: defaultUserAccount.last, 
            initials: defaultUserAccount.initials,
            allowTransferOnlyTemplates: "true"
        };

        BCMSRecord.batch([
            User.update(user)
        ], context, Classes);

        setUpdateComp(true);
    });
    
    return <TransfersPage data={ data } />;
}